import React from "react"
import { FormFieldRaw, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "../ui/form"
import { useFormContext, UseFormReturn } from "react-hook-form"
import { Slot } from "@radix-ui/react-slot"

export interface FormFieldProps {
  form?: UseFormReturn<any>
  name: string
  label?: string
  description?: string
  tip?: string // TODO: add tooltip
  children: React.ReactNode
  valueAsNumber?: boolean
  required?: boolean
}

const FormField = (props: FormFieldProps) => {
  const { register } = useFormContext() // retrieve all hook methods

  // Uncontrolled
  if (["Input"].includes(props.children?.type?.name)) {
    return (
      <div className="text-left grid gap-2">
        {props.label && <FormLabel>{props.label}</FormLabel>}
        <Slot {...register(props.name, { valueAsNumber: props.valueAsNumber })}>{props.children}</Slot>
        {props.description && <FormDescription>{props.description}</FormDescription>}
        <FormMessage />
      </div>
    )
  }

  // Controlled
  return (
    <FormFieldRaw
      control={props.form?.control}
      name={props.name}
      render={({ field }) => (
        <FormItem className="text-left">
          {props.label && (
            <FormLabel>
              {props.label}
              {props.required && <span className="text-red-500">*</span>}
            </FormLabel>
          )}
          <FormControl>
            <Slot {...field}>{props.children}</Slot>
          </FormControl>
          {props.description && <FormDescription>{props.description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

// const FormFieldControlled = (props: FormFieldProps<any>) => {
//   return (
//     <FormFieldRaw
//       control={props.form.control}
//       name={props.name}
//       render={({ field }) => (
//         <FormItem className="text-left">
//           {props.label && <FormLabel>{props.label}</FormLabel>}
//           <FormControl>
//             <Slot {...field}>{props.children}</Slot>
//           </FormControl>
//           {props.description && <FormDescription>{props.description}</FormDescription>}
//           <FormMessage />
//         </FormItem>
//       )}
//     />
//   )
// }

export default FormField
